import { envNoError } from 'util/env'

export const addDelimiter = (num: number, delimiter = ',') => {
  return Math.floor(num)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${delimiter}`) // NOSONAR
}

export const formatRedirectUri = (redirectUri: string) => {
  const publicUrl = envNoError('PUBLIC_URL')
  if (publicUrl) {
    return `${publicUrl}/${redirectUri}`
  }
  return `${redirectUri}`
}

export const stringToNumericalHashCode = (s: string) => {
  let hash = 0
  let i
  let chr

  if (s.length === 0) return `${hash}`
  for (i = 0; i < s.length; i++) {
    chr = s.charCodeAt(i)
    // tslint:disable-next-line:no-bitwise
    hash = (hash << 5) - hash + chr
    // tslint:disable-next-line:no-bitwise
    hash |= 0
  }
  return `${hash}`
}

export const removePrefixNumbering = (str: string): string => str.replace(/^\d+\.\s+(.+)$/, '$1') // NOSONAR

export const prependEuro = (value: number | string) => `€${value}`
export const appendPercent = (value: number | string) => `${value}%`
